/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { Link } from 'react-router-dom';
import { mediciLiberiProfessionistiRetroactivities, mlpMassimali } from '../../../common/constants';

function MLPQuoteInfo({ medicoLiberoProfessionistaQuote, setShowGreeniaAI }) {
    return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo Medico Libero Professionista</h5>
                <hr />
                <div>
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Nome:
                                        </strong>
                                        {' '}
                                        {medicoLiberoProfessionistaQuote?.quote?.name}
                                    </small>
                                </p>
                            </div>
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Massimale:
                                        </strong>
                                        {' '}
                                        {mlpMassimali.find((item) => item.id === medicoLiberoProfessionistaQuote?.quote?.massimale)?.name || 'Non specificato'}
                                    </small>
                                </p>
                            </div>
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Retroattività:
                                        </strong>
                                        {' '}
                                        {mediciLiberiProfessionistiRetroactivities.find((item) => item.id === medicoLiberoProfessionistaQuote?.quote?.retroactivity)?.name || 'Non specificato'}
                                    </small>
                                </p>
                            </div>
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Prezzo:
                                        </strong>
                                        {' '}
                                        {
                                            Number(medicoLiberoProfessionistaQuote?.quote?.price).toLocaleString('it-IT', {
                                                style: 'currency',
                                                currency: 'EUR',
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }
                                    </small>
                                </p>
                            </div>
                            <div className="col-12">
                                <hr />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/rc-professionale-sanita/medici-liberi-professionisti/${medicoLiberoProfessionistaQuote?.fastQuoteId}`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MLPQuoteInfo;
